@if (user()) {
	<a class="ajaxIgnore"
	   id="document"
	   href="https://www.allianz.de/impressum/"
	   target="_blank">
		{{"frame.footer.impressum" | msgKeyCached}}
	</a>
} @else {
	@if ('showLinkToImpressumBeforeLogin' | feature | async) {
		<a class="ajaxIgnore"
		   id="document"
		   href="https://www.allianz.de/impressum/"
		   target="_blank">
			{{"frame.footer.impressum" | msgKeyCached}}
		</a>
	}
}
